import React, {Component} from 'react';
import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@material-ui/icons/Settings';
import MenuIcon from '@material-ui/icons/Menu';
import { Redirect, withRouter } from 'react-router-dom';
import { withStyles, Grid } from '@material-ui/core';
import logo from '../images/logo.png'; 
import PropTypes from 'prop-types';
import SideDrawerMain from './sideDrawer/SideDrawerMain';
import SideDrawerLogin from './sideDrawer/SideDrawerLogin';
import withSizes from 'react-sizes';
import ArbitratorFeeCalculator from './ArbitrationFeeCalculator';
import ArbitrationProcedure from './ArbitrationProcedure';
import ClausesAgreement from './ClausesAgreement';
import ArbitrationAgreement from './ArbitrationAgreement';
import ArbitrationRules from './ArbitrationRules';
import ArbitrationList from './ArbitrationList';
import AboutOnlineArbitration from './AboutOnlineArbitration';
import ArbitrationListForView from './ArbitrationListForView';
import OnlineArbitrationClause from './OnlineArbitrationClause';
import GeneralDialog from './GeneralDialog';
import { connect } from 'react-redux';

const aboutOnlineArbitration = <AboutOnlineArbitration />;
const arbitrationListForView = <ArbitrationListForView />;
const arbitrationRules = <ArbitrationRules />;
const arbitrationProcedures = <ArbitrationProcedure />;
const arbitrationAgreement = <ArbitrationAgreement />;
const onlineArbitrationClauses = <ClausesAgreement />;
const arbitratorFeeCalculator = <ArbitratorFeeCalculator />;

//onlineArbitrationClause
const styles = {
    root: {
        background: 'transparent',
        // boxShadow: 'none',
        // padding: '0',
        width:'100%'
      },
    menuButton: {
        // marginLeft: 'auto',
        //alignItems: 'right',
    },
  };

  
class PrimaryAppBarMobile extends Component{

    state = {
        windowHeight: undefined,
        windowWidth: undefined,
        right: false,
        left:false,
        showProcedure:false,
        showCalculator:false,
        showOnlineArbitrationClauses: false,
        showArbitrationListForView: false
    };

    handleResize = () => {
        this.setState({
          windowHeight: window.innerHeight,
          windowWidth: window.innerWidth,
        });
        this.innerWidth = window.innerWidth;
        console.log(
          "PrimayAppBarMobile Window Size: window.innerHeight: " +
            window.innerHeight +
            " window.innerWidth: " +
            window.innerWidth +
            " div 4: " +
            window.innerWidth / 4
        );
      };

    componentDidMount(){
        this.showDialog = this.showDialog.bind(this)
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
    }
    
    toggleDrawer = (side, open) => () => {
        this.setState({
          [side]: open,
        });
    };
    
    componentWillUnmount(){
        window.removeEventListener("resize", this.handleResize);
    }

    showDialog(v, e){
        this.setState({
            [v]: e
        })
    }

    render(){
        const { classes, isAuthenticated, logoSize, lang } = this.props;
        const onlineArbitrationClause = <OnlineArbitrationClause windowWidth={this.state.windowWidth} copy={this.context.t("copy")} copied={this.context.t("copied")} text={this.context.t("onlineArbitrationClause")} mainText={this.context.t("The following clause can be added by the parties to a contract who wish to have any future disputes referred to efficient arbitration in HKAS\’s Online Arbitration Platform:")} title={this.context.t("Arbitration Clause")} />;
        const twofa = localStorage.getItem('twofa');
        if(isAuthenticated && twofa){
            return (
                <Redirect to='/cases' />
            );
        }
        else{
            return(
                <div className={classes.root}>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="flex-start"
                        >
                        { lang == 'en' && <a width={logoSize} height={logoSize} href="https://www.hkarbsoc.org.hk/en/HKAS_main.htm"><img alt ="" src={logo} /></a> }
                        { lang == 'cn' && <a width={logoSize} height={logoSize} href="https://www.hkarbsoc.org.hk/hk/HKAS_main.htm"><img alt ="" src={logo} /></a> }
                        <IconButton
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="Menu"
                            onClick={this.toggleDrawer('left', true)}
                        >
                                <MenuIcon style={{color: '#B71C1C'}}/>
                        </IconButton>
                        </Grid>
                    {this.state.showProcedure && <GeneralDialog component={arbitrationProcedures} typeDialog={'showProcedure'} showDialog={this.showDialog}  />}
                    {this.state.showCalculator && <GeneralDialog component={arbitratorFeeCalculator} typeDialog={'showCalculator'} showDialog={this.showDialog}  />}
                    {this.state.showOnlineArbitrationClauses && <GeneralDialog component={onlineArbitrationClause} typeDialog={'showOnlineArbitrationClauses'} showDialog={this.showDialog}  />}
                    {this.state.showArbitrationListForView && <GeneralDialog component={arbitrationListForView} typeDialog={'showArbitrationListForView'} showDialog={this.showDialog}  />}
                    
                    <SideDrawerLogin showDialog={this.showDialog} openDrawer={this.state.left} toggleDrawer={this.toggleDrawer}/>
                </div>
    
            );
        }
        
    }
}

const mapStateToProps = (state) => {
    // console.log('#Navtabs state: '+JSON.stringify(state) )
    return {
      isAuthenticated: state.auth.token !== null,
      isLoading: state.userInfo.isLoading,
      userId: state.auth.userId,
      twofa: state.auth.twofa,
      respondent_docs: state.caseInfo.respondent_docs,
      arbitrator_docs: state.caseInfo.arbitrator_docs,
      claimant_docs: state.caseInfo.claimant_docs,
      admin_docs: state.caseInfo.admin_docs,
      caseId: state.caseInfo.caseId,
      userType: state.caseInfo.userType,
      caseData: state.caseInfo.caseData,
    //   typeOfAccount: (state.auth.typeOfAccount !== undefined ? state.auth.typeOfAccount : state.userInfo.typeOfAccount),
      //newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`] ? state.caseInfo[`${state.caseInfo.userType}_newAccount`]/*['newAccount']*/ : null,
      newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
    }
  }

const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),
  
  })

PrimaryAppBarMobile.contextTypes = {
    t: PropTypes.func
  }

// export default withStyles(styles)(withSizes(mapSizesToProps) (PrimaryAppBarMobile));
export default connect(mapStateToProps)(withSizes(mapSizesToProps)(withStyles(styles)(withRouter(PrimaryAppBarMobile))));